export const ModalActionTypes = {
    ADD_MODAL: 'modal/ADD_MODAL',
    REMOVE_MODAL: 'modal/REMOVE_MODAL',
    CLOSE_ALL_MODALS: 'modal/CLOSE_ALL_MODALS',
}